import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './successfulPayment.module.css'
import '../../components/text/Text.css'
import routes from '../../router/routes'
import { clevertapEvents } from '../../labels'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import { DetailSale } from '../../components/modal/DetailSaleModal'
import { TransactionResponse } from '../../services/commerce'

export default function SuccessfulPayment() {
    const state = useLocation()

    const navigation = useNavigate()
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    const navigateToHome = () => {
        navigation(`${routes.home}`)
    }

    const navigateToPayment = () => {
        navigation(`/${routes.payment}`)
    }

    const voucherEventParms = {
        pageName: 'SuccessfulPayment',
        pageURL: routes.successPayment,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    useEffect(() => {
        track(
            clevertapEvents.amiposweb_cobrafacil_pagoqr_comprobante,
            voucherEventParms
        )
    }, [])

    function getFormattedDate(): string {
        const now = new Date()

        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0') // Mes empieza en 0
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }

    return (
        <div className={styles.bg}>
            <div className={styles.card}>
                <DetailSale
                    sale={
                        {
                            sToken: '3487990100',
                            dTransaccion: getFormattedDate(),
                            nMonto: state.state?.data?.nMonto || 0,
                            idTransaccion: state.state?.data?.CodAutorizador,
                        } as TransactionResponse
                    }
                    onGoHome={navigateToHome}
                    onCustomBtn={navigateToPayment}
                    customBtnText="Hacer otro cobro"
                />
            </div>
        </div>
    )
}
